<template>
    <form id="onboarding-de" class="wrapper tab-info" role="form" method="post">
        <header>
            <span class="new-headline-xlg text-centered">Kein Problem, es gibt verschiedene Wege in die Vitadio-App:</span>
        </header>

        <div class="text-wrapper">
            <ul class="list-w-check">
                <li>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                            <span>check</span>
                        </span>
                    </figure>
                    <span class="new-text-xl">Fragen Sie Ihren Arzt oder Ihre Ärztin beim nächsten Besuch nach einem Rezept für Vitadio. Zeigen Sie ihm oder ihr gerne den <a href="/uploads/manual_uploads/Die_Vitadio_App_auf_Rezept_Fachkreise.pdf">Informationsflyer</a></span>
                </li>
                <li>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                            <span>check</span>
                        </span>
                    </figure>
                    <span class="new-text-xl">Erhalten Sie Ihr Rezept oder Ihren Diagnosenachweis von der <a href="/teleclinic">Teleclinic</a></span>
                </li>
                <li>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                            <span>check</span>
                        </span>
                    </figure>
                    <span class="new-text-xl">Fragen Sie direkt bei Ihrer Krankenkasse nach einem Zugang</span>
                </li>
                <li>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                            <span>check</span>
                        </span>
                    </figure>
                    <span class="new-text-xl">Wenn Sie doch noch einen Diagnosenachweis finden, <a href="/rezept-service">laden Sie diesen hier hoch</a></span>
                </li>
            </ul>

            <v-button label="Weiter" position="center" @onClick="next()"></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                showDisclaimer: false
            }
        },

        methods: {
            next() {
                setTimeout(() => {
                    this.$emit('clicked', 'how')
                }, 250);
            },
        }
    }
</script>